import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChevronThinUp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" {...props}>
    <path fill="#343333" fillRule="evenodd" d="m0 9 .668.668L6 4.336l5.332 5.332L12 9 6 3z" clipRule="evenodd" />
  </svg>
);
export default SvgChevronThinUp;
